import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import tgApi from '../../utils/tgApi';

export const fetchSendLogs = createAsyncThunk(
  'messaging/fetchLogs',
  async (params, { rejectWithValue }) => {
    try {
      const { data } = await tgApi.getSendLogs(params);
      return data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.detail || '발송 로그를 불러올 수 없습니다.');
    }
  }
);

export const sendMessage = createAsyncThunk(
  'messaging/send',
  async (payload, { rejectWithValue }) => {
    try {
      const { data } = await tgApi.sendToSelected(payload);
      return data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.detail || '발송에 실패했습니다.');
    }
  }
);

export const sendSmsMessage = createAsyncThunk(
  'messaging/sendSms',
  async (payload, { rejectWithValue }) => {
    try {
      const { data } = await tgApi.sendSms(payload);
      return data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.detail || 'SMS 발송에 실패했습니다.');
    }
  }
);

export const sendDirectEmail = createAsyncThunk(
  'messaging/sendDirectEmail',
  async (payload, { rejectWithValue }) => {
    try {
      const { data } = await tgApi.sendDirect(payload);
      return data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.detail || '직접 이메일 발송에 실패했습니다.');
    }
  }
);

export const sendDirectSms = createAsyncThunk(
  'messaging/sendDirectSms',
  async (payload, { rejectWithValue }) => {
    try {
      const { data } = await tgApi.sendSmsDirect(payload);
      return data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.detail || '직접 SMS 발송에 실패했습니다.');
    }
  }
);

const messagingSlice = createSlice({
  name: 'messaging',
  initialState: {
    logs: [],
    sending: false,
    loading: false,
    error: null,
    result: null,
  },
  reducers: {
    clearMessagingError: (state) => { state.error = null; },
    clearMessagingResult: (state) => { state.result = null; },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchSendLogs.pending, (state) => { state.loading = true; })
      .addCase(fetchSendLogs.fulfilled, (state, action) => { state.loading = false; state.logs = action.payload; })
      .addCase(fetchSendLogs.rejected, (state, action) => { state.loading = false; state.error = action.payload; })
      .addCase(sendMessage.pending, (state) => { state.sending = true; state.error = null; })
      .addCase(sendMessage.fulfilled, (state, action) => { state.sending = false; state.result = action.payload; })
      .addCase(sendMessage.rejected, (state, action) => { state.sending = false; state.error = action.payload; })
      .addCase(sendSmsMessage.pending, (state) => { state.sending = true; state.error = null; })
      .addCase(sendSmsMessage.fulfilled, (state, action) => { state.sending = false; state.result = action.payload; })
      .addCase(sendSmsMessage.rejected, (state, action) => { state.sending = false; state.error = action.payload; })
      .addCase(sendDirectEmail.pending, (state) => { state.sending = true; state.error = null; })
      .addCase(sendDirectEmail.fulfilled, (state, action) => { state.sending = false; state.result = action.payload; })
      .addCase(sendDirectEmail.rejected, (state, action) => { state.sending = false; state.error = action.payload; })
      .addCase(sendDirectSms.pending, (state) => { state.sending = true; state.error = null; })
      .addCase(sendDirectSms.fulfilled, (state, action) => { state.sending = false; state.result = action.payload; })
      .addCase(sendDirectSms.rejected, (state, action) => { state.sending = false; state.error = action.payload; });
  },
});

export const { clearMessagingError, clearMessagingResult } = messagingSlice.actions;
export default messagingSlice.reducer;
